import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scCurrency',
  standalone: false
})
export class ScCurrencyPipe implements PipeTransform {
  transform(val: number): string {
    return this.setCurrencyFormat(val);
  }

  setCurrencyFormat(value) {
    const text = this.parse((value && typeof value === 'number' && value.toFixed(0)) || value || 0);
    const newVal = (Number.parseInt(text || '0', 10) || 0).toString();
    return '$ ' + this.addThousandsSeparator(newVal, '.');
  }

  parse(value) {
    const text = value && value.toString();
    if (!text || text.length === 0 || text === '') return '0';
    let withoutDecimals = text.replace(/,\d+$/, '');
    withoutDecimals = withoutDecimals.replace(/\.\d{1,2}$/, '');
    return withoutDecimals.replace(/\D/g, '');
  }

  parseInt(value) {
    return Number.parseInt(this.parse(value), 10);
  }

  addThousandsSeparator(n, thousandsSeparatorSymbol) {
    return n.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparatorSymbol);
  }
}
